import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=27a9fc48&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=27a9fc48&prod&scoped=true&lang=css"
import style1 from "./chat.vue?vue&type=style&index=1&id=27a9fc48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9fc48",
  null
  
)

export default component.exports